var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFillZone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0267 12.2933C16.5333 12.0933 16 12.04 15.48 12.1467C14.96 12.2533 14.4933 12.5067 14.12 12.88C13.7467 13.2533 13.4933 13.7333 13.3867 14.24C13.28 14.76 13.3333 15.2933 13.5333 15.7867C13.7333 16.28 14.08 16.6933 14.52 16.9867C14.96 17.28 15.48 17.44 16 17.44C16.7067 17.44 17.3867 17.16 17.88 16.6533C18.3867 16.1467 18.6667 15.48 18.6667 14.7733C18.6667 14.24 18.5067 13.7333 18.2133 13.2933C17.92 12.8533 17.5067 12.5067 17.0133 12.3067L17.0267 12.2933Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.26667 2 2 8.26667 2 16C2 23.7333 8.26667 30 16 30C23.7333 30 30 23.7333 30 16C30 8.26667 23.7333 2 16 2ZM21.8533 19.16C21.8533 19.16 21.6533 19.4267 21.6267 19.4667L16 26.1067L10.3733 19.48L10.1467 19.1733C9.18667 17.9067 8.66667 16.36 8.66667 14.7733C8.66667 12.8267 9.44 10.96 10.8133 9.58667C12.1867 8.21333 14.0533 7.44 16 7.44C17.9467 7.44 19.8133 8.21333 21.1867 9.58667C22.56 10.96 23.3333 12.8267 23.3333 14.7733C23.3333 16.36 22.8133 17.9067 21.8533 19.1733V19.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFillZone);
export default __webpack_public_path__ + "static/media/ic-fill-zone.8ab806b87230be62e7a1b2b5320f31aa.svg";
export { ForwardRef as ReactComponent };